import { signOut } from "aws-amplify/auth";
import { logMessage } from "../../utils/amplifyLogger";
import { setAgentStateOffline } from "../../utils/agentStateChangeUtil";
import { logOutOfCcp } from "../../services/auth";
import "amazon-connect-streams";

export const setAgentOffline = async (
  screenName = "Idle Timer",
  instanceUrl: string | null,
  userEmail: string | null,
) => {
  await setAgentStateOffline(screenName);
  await logOutOfCcp(instanceUrl ?? "", "SbuxIdleTimer", userEmail ?? "");
};

export const setLogout = async (
  screenName = "Idle Timer",
  instanceUrl: string | null,
  userEmail: string | null,
) => {
  try {
    await setAgentOffline(screenName, instanceUrl, userEmail);
    await signOut({
      global: true,
      oauth: {
        redirectUrl: process.env.REACT_APP_AGENTDESKTOP_REDIRECTSIGNOUT_URL,
      },
    });
  } catch (err) {
    logMessage(screenName, `Signout failure. ${err}`, `error`);
  }
};
